import { createSelector } from 'reselect'

import { paramSelector } from '../../utils/selectors'
import { RootState } from '../types'

export const selectState = createSelector(
  (state: RootState) => state.gtm,
  c => c
)

export const isOrderTracked = createSelector(
  selectState,
  paramSelector<string>(),
  (x, orderId) => !!x.purchases[orderId]
)
